<template>
  <div>
    <div class="ts-relative ts-mt-1">
      <div
        class="ts-absolute ts-inset-y-0 ts-left-0 ts-flex ts-items-center ts-pl-3 ts-pointer-events-none"
      >
        <svg
          class="ts-w-5 ts-h-5 ts-text-gray-500 dark:ts-text-gray-400"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </div>
      <input
        v-model="search"
        type="text"
        id="table-search"
        class="ts-border ts-text-gray-900 ts-text-sm ts-rounded  ts-outline-none ts-block ts-w-full ts-pl-10 ts-p-2"
        :placeholder="$t('visitation.typeToSearchProvince')"
      />
    </div>
    <div
      class="ts-h-40 ts-border ts-border-gray-100 700 ts-p-3 ts-overflow-y-scroll"
    >
      <table class="ts-w-full">
        <tr>
          <td class="ts-w-3 ts-pr-4 ts-p-1 ts-sticky ts-top-0 ts-z-10 ts-bg-white" style="width: 10px">
            <input 
              type="checkbox" 
              class="ts-cursor-pointer" 
              id="p_check_all"
              :checked="isCheckAll"
              @change="onCheckAll"
            />
          </td>
          <td class="ts-sticky ts-top-0 ts-z-10 ts-bg-white">
            <label for="p_check_all" class="ts-mb-0 ts-font-normal ts-cursor-pointer">{{ $t('visitation.checkAll') }}</label>
          </td>
        </tr>
        <tr v-for="(p, index) in itemList" :key="index" class="ts-border-b">
          <td class="ts-w-3 ts-pr-4 ts-p-1">
            <input
              type="checkbox"
              v-model="checkedItem"
              :value="p.province_code"
              @change="onChange"
              :id="'p_check_' + index"
              class="ts-cursor-pointer"
            />
          </td>
          <td>
            <label
              :for="'p_check_' + index"
              class="ts-mb-0 ts-font-normal ts-cursor-pointer"
            >
              {{ p.province_code + '-' + p.name_kh }}
              <span class="ts-text-blue-700">{{ p.name_en }}</span>
            </label>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'provinceSearch',
  props: ['items', 'value'],
  data() {
    return {
      search: '',
      checkedItem: [],
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    itemList() {
      return this.items.filter(
        v =>
          v.province_code.indexOf(this.search.trim()) >= 0 ||
          v.name_kh.indexOf(this.search.trim()) >= 0 ||
          v.name_en.toLowerCase().indexOf(this.search.toLowerCase().trim()) >= 0
      )
    },
    isCheckAll(){
      if(!this.checkedItem.length) return false
      return this.checkedItem.length == this.items.length;
    }
  },
  methods: {
    onChange(e) {
      if (!e.target.checked) {
        var province = this.model.customer_list.filter(
          c => c.province_code == e.target.value
        )
        province.forEach(v => {
          this.model.customer_list.splice(
            this.model.customer_list.indexOf(this.findById(v)),
            1
          )
        })
      }
      this.$emit('itemCheck', this.checkedItem)
    },
    findById(v) {
      return this.model.customer_list.find(c => c.province_code == v.province_code)
    },
    onCheckAll(e){
      if(!e.target.checked){
        this.checkedItem = []
        this.model.customer_list = []
        this.$emit('itemCheck', [])
        return
      }
      this.checkedItem = this.itemList.map(el => el.province_code)

      this.$emit('itemCheck', this.checkedItem)
    }
  }
}
</script>
